import React, { useCallback } from 'react';

import NodeCategories, { NodeDataType } from '../models/node-data';

interface IProps {
  data: string[];
}

export default function MenuNodeList({ data, ...props }: IProps) {
  const getImageUrl = useCallback(
    (url: string) => `${(url ?? '').replace('./', '/')}`,
    [],
  );

  const onDragStart = useCallback(
    (event: React.DragEvent<HTMLDivElement>, nodeType: NodeDataType) => {
      event.dataTransfer.setData('application/reactflow', nodeType);
      event.dataTransfer.effectAllowed = 'move';
    },
    [],
  );

  if (data.length === 0) return null;
  return (
    <div
      {...props}
      className="flex w-full flex-row flex-nowrap gap-2 overflow-x-auto whitespace-nowrap bg-linear-gradient p-2"
    >
      {data.map((key, i) => {
        const node = NodeCategories[key as keyof typeof NodeCategories];
        return (
          <div
            data-testid={`menu-node-${key}`}
            key={`node${i}`}
            className="relative inline-block cursor-grab rounded border border-gray-300 bg-white p-2 first:ml-auto last:mr-auto"
            onDragStart={(event) => onDragStart(event, key as NodeDataType)}
            draggable
            style={{ flex: '0 0 auto' }}
          >
            {node.image || node.imageSidebar ? (
              <div className="flex h-full min-w-28 flex-col items-center justify-between gap-1 font-medium">
                <span className="text-center font-medium text-blue-400">
                  {node.name}
                </span>
                <img
                  src={getImageUrl(
                    (node.imageSidebar ||
                      (node.rotatable
                        ? node.image?.replace(`${node.name}`, `${node.name}/0`)
                        : (node?.image ?? ''))) ??
                      '',
                  )}
                  alt={node.name}
                  className="h-20 object-contain"
                />
              </div>
            ) : (
              <span className="text-sm">{node.name}</span>
            )}
          </div>
        );
      })}
    </div>
  );
}
